import { pluralize } from 'utils'
import { useImagePickerContext } from './ImagePickerContext'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Counter, CounterSize, CounterVariant } from 'blaze-ui/Counter/Counter'
import Styles from './SelectionCount.module.scss'
import { entityName } from './utils'

export const SelectionCount = () => {
  const { selectedImages, maxCount } = useImagePickerContext()
  const { isMobile } = useResponsiveDesign()
  const entity = entityName(selectedImages)

  if (isMobile) {
    return (
      <div className={Styles.mobileCount}>
        <Counter variant={CounterVariant.Dark} size={CounterSize.md} count={selectedImages.length} />
        <Text variant="smallList">{pluralize(entity, selectedImages.length)} selected</Text>
        <Text variant="smallList">({maxCount} max)</Text>
      </div>
    )
  }

  return (
    <div className={Styles.count}>
      <Text variant="smallList">
        {`${selectedImages.length} ${pluralize(entity, selectedImages.length)} selected`}
      </Text>
    </div>
  )
}
